import { EventCatalogFromKeys, EventType } from "../../../types";

export const CReportsEventKeys = {
  ADMIN_CREPORTS_PAGE_VIEW: "admin-creports-page-view",
  CREPORTS_CLIENT_EXPORT: "creports-client-export",
} as const;

export const CReportsEventCatalog: EventCatalogFromKeys<
  typeof CReportsEventKeys
> = {
  [CReportsEventKeys.ADMIN_CREPORTS_PAGE_VIEW]: {
    description: "Admin viewed the coordinator reports page",
    eventType: EventType.PAGE_VIEW,
    id: CReportsEventKeys.ADMIN_CREPORTS_PAGE_VIEW,
  },
  [CReportsEventKeys.CREPORTS_CLIENT_EXPORT]: {
    description: "User exported data in CReportsClient",
    eventType: EventType.INTERACTION,
    id: CReportsEventKeys.CREPORTS_CLIENT_EXPORT,
  },
};
